import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { TOAST_TYPES, ENTITYNAME, CREDIT_DEBIT, LOCALSTORAGE_KEY } from "../../framework/constant/constant";
import ToastNotification from "../../components/ToastNotification";
import BossDialog from "../../components/BossDialog";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";

const ContractCreditDebitNotesForm = (props) => {
    const lang = useTranslation();
    const { onSaveData, cancelEdit } = props;

    let user = utility.getValue(LOCALSTORAGE_KEY.userData);

    const blankDataItem = {
        ...props.data,
        CostType: props.data?.CostType ?? "",
        CreditDebit: props.data?.CreditDebit ?? {},
        Supplier: props.data?.Supplier ?? {},
        Amount: props.data?.Amount ?? 0,
        TaxAmount: props.data?.TaxAmount ?? 0
    };

    const [dataItem, setDataItem] = useState(blankDataItem);

    const [suppliers, setSuppliers] = useState([]);
    const [creditDebitOptions, setCreditDebitOptions] = useState([])

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        let supplierRes = await API.getDataLookup(ENTITYNAME.Licensor, { sort: { Description: 1 } });
        setSuppliers(supplierRes.data);
        const creditDebitOptions = Object.keys(CREDIT_DEBIT).map(key => ({
            _id: CREDIT_DEBIT[key],
            Description: key
        }));
        setCreditDebitOptions(creditDebitOptions);
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const isValid = () => {
        if (!dataItem.CostType) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_cost_type_error_message });
            return false;
        }
        if (!dataItem.CreditDebit || Object.keys(dataItem.CreditDebit).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_credit_debit_error_message });
            return false;
        }
        if (!dataItem.Supplier || Object.keys(dataItem.Supplier).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_supplier_error_message });
            return false;
        }
        if (dataItem.Amount === "" || dataItem.Amount === null) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_amount_error_message });
            return false;
        }
        if (dataItem.Amount !== "" && dataItem.Amount !== null && Number(dataItem.Amount) <= 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.amount_cannot_be_zero_or_negative_error_message });
            return false;
        }
        if (dataItem.TaxAmount !== "" && dataItem.TaxAmount !== null && Number(dataItem.TaxAmount) < 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.tax_can_not_be_negative_error_message });
            return false;
        }
        return true;
    };

    const handleSubmit = () => {
        if (isValid()) {
            const creditDebitNote = {
                ...dataItem,
                CostType: dataItem.CostType,
                CreditDebit: dataItem?.CreditDebit && Object.keys(dataItem?.CreditDebit).length > 0 ? {
                    _id: dataItem?.CreditDebit?._id,
                    Description: dataItem?.CreditDebit?.Description,
                } : {},
                Supplier: dataItem?.Supplier && Object.keys(dataItem?.Supplier).length > 0 ? {
                    _id: dataItem?.Supplier?._id,
                    Name: dataItem?.Supplier?.Name,
                } : {},
                Amount: dataItem.Amount,
                TaxAmount: dataItem.TaxAmount,
                AddOn: new Date().getTime(),
                AddBy: {_id : user?._id, Name: user?.name}
            };

            onSaveData(creditDebitNote);
        }
    };

    return (
        <BossDialog title={lang.credit_debit_notes_label} onClose={cancelEdit} width="620px" height="auto">
            <div className="p-1">
                <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit} />
                <div className="row mt-2">
                    <div className="col-4 form-group">
                        <label htmlFor="CostType">{lang.cost_type_label} *</label>
                        <input
                            type="text"
                            name="CostType"
                            placeholder="Enter Cost Type"
                            className="form-control form-control-sm"
                            value={dataItem.CostType}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4 form-group">
                        <label htmlFor="CreditDebit">{lang.credit_debit_label} *</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={creditDebitOptions}
                            name="CreditDebit"
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.CreditDebit}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4 form-group">
                        <label htmlFor="Supplier">{lang.supplier_label} *</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={suppliers}
                            name="Supplier"
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.Supplier}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-1">
                    <div className="col-6 form-group">
                        <label htmlFor="Amount">{lang.amount_label} *</label>
                        <input
                            type="number"
                            name="Amount"
                            min="0"
                            placeholder="Enter Amount"
                            className="form-control form-control-sm"
                            value={dataItem.Amount}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6 form-group">
                        <label htmlFor="TaxAmount">{lang.tax_amount_label} *</label>
                        <input
                            type="number"
                            name="TaxAmount"
                            min="0"
                            placeholder="Enter Tax Amount"
                            className="form-control form-control-sm"
                            value={dataItem.TaxAmount}
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
        </BossDialog>
    );
};

export default ContractCreditDebitNotesForm;
